import { z } from "zod";

export const AddressOutputSchema = z.object({
  id: z.string(),
  addressName: z.string(), // Home, Work, etc
  streetName: z.string(),

  address2: z.string().optional(),

  city: z.string(),
  state: z.string(),
  zip: z.string(),
  country: z.string().min(2).max(2), // ISO 3166-1 alpha-2 country code

  placeId: z.string().optional(),
  lat: z.number().min(-90).max(90).optional(),
  lng: z.number().min(-180).max(180).optional(),
  geohash: z.string().optional(),
  uspsValidatedDate: z.iso.date().optional(),
});

export type AddressOutputType = z.infer<typeof AddressOutputSchema>;

export const AddressInputSchema = z.object({
  addressName: z.string(),
  streetName: z.string(),
  address2: z.string().optional(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  country: z.string(),
  placeId: z.string().optional(),
  lat: z.number().optional(),
  lng: z.number().optional(),
  geohash: z.string().optional(),

  uspsValidatedDate: z.iso.date().optional(),
});

export type AddressInputType = z.infer<typeof AddressInputSchema>;

export const UspsAddressValidationResponseSchema = z.object({
  firm: z.string().max(50).optional(),
  address: z.object({
    streetAddress: z.string().min(1).max(50),
    streetAddressAbbreviation: z.string().max(50).optional(),
    secondaryAddress: z.string().max(50).optional(),
    cityAbbreviation: z.string().optional(),
    city: z.string().min(1).max(28),
    state: z.string().length(2),
    ZIPCode: z.string().regex(/^\d{5}$/),
    ZIPPlus4: z
      .string()
      .regex(/^\d{4}$/)
      .nullable()
      .optional(),
    urbanization: z.string().max(96).optional(),
  }),
  additionalInfo: z.object({
    deliveryPoint: z.string().optional(),
    carrierRoute: z.string().max(5).optional(),
    DPVConfirmation: z.enum(["Y", "D", "S", "N"]).optional(),
    DPVCMRA: z.enum(["Y", "N"]).optional(),
    business: z.enum(["Y", "N"]).optional(),
    centralDeliveryPoint: z.enum(["Y", "N"]).optional(),
    vacant: z.enum(["Y", "N"]).optional(),
  }),
  corrections: z.array(
    z.object({
      code: z.string(),
      text: z.string(),
    }),
  ),
  matches: z
    .array(
      z.object({
        code: z.string(),
        text: z.string(),
      }),
    )
    .optional(),
  warnings: z.array(z.string()).optional(),
});

// TypeScript type inferred from Zod schema
export type UspsAddressValidationResponse = z.infer<typeof UspsAddressValidationResponseSchema>;

export const UspsValidationResultSchema = z.object({
  valid: z.boolean(),
  errors: z.array(z.string()),
});

export type UspsValidationResult = z.infer<typeof UspsValidationResultSchema>;
